import { IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { updateBankStatementIdBalanceTransfer } from "../../../Api/BalanceTransfer";

interface BalanceTransferProps {
  isOpen: boolean;
  onClose: () => void;
  transactionAmount: number;
  TransferFromBankstatementId: string;
  TransferToBankstatementId: string;
  BalanceTransfer: any[];
  fetchBalanceTransferData: (DrbalanceTransferAssignId: string, CrbalanceTransferAssignId: string, currentTransactionAmount: number) => Promise<void>;
  fetchAssignedBalanceTransferData: (CrstatementId: string, DrstatementId: string) => Promise<void>;
  onSuccess?: () => void;
}

const BalanceTransferModel = ({
  isOpen,
  onClose,
  transactionAmount,
  TransferFromBankstatementId,
  TransferToBankstatementId,
  BalanceTransfer,
  fetchBalanceTransferData,
  fetchAssignedBalanceTransferData,
  onSuccess,
}: BalanceTransferProps) => {
  const [balanceTransferIds, setbalanceTransferIds] = useState<string[]>([]);

  const handleCheckboxChange = (balanceId: string) => {
    setbalanceTransferIds((prevSelected) =>
      prevSelected.includes(balanceId)
        ? prevSelected.filter((id) => id !== balanceId)
        : [...prevSelected, balanceId]
    );
  };

  const selectedBalanceTransferAmount = BalanceTransfer.reduce((total, balance) => {
    return balanceTransferIds.includes(balance.id) ? total + balance.amount : total;
  }, 0);

  const isSubmitEnabled = selectedBalanceTransferAmount === transactionAmount;

  const handleSubmit = async () => {
    try {
      await updateBankStatementIdBalanceTransfer(balanceTransferIds, TransferFromBankstatementId, TransferToBankstatementId);
      await fetchBalanceTransferData(TransferFromBankstatementId, TransferToBankstatementId, transactionAmount);
      await fetchAssignedBalanceTransferData(TransferFromBankstatementId, TransferToBankstatementId);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Error updating bank statement ID:", error);
    }
  };


  return (
    <div>
      <div>
        <div className="flex justify-between items-center border-b pb-1">
          <h1 className="text-xl font-semibold text-blue-700">Assign Balance Transfer</h1>
        </div>

        <div className="mt-4 overflow-auto scroll-hide" style={{ maxHeight: "300px", scrollbarWidth: "none", msOverflowStyle: "none" }}>
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-1 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                <th
                  scope="col"
                  className="py-3.5 px-4 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <span>From</span>
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <span>To</span>
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <span>Donation Type</span>
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <span>Donation Purpose</span>
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <span>Transfered On</span>
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <span>Amount</span>
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                >
                  <span>Description</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {BalanceTransfer.length === 0 ? (
                <tr>
                  <td colSpan={7} className="px-1 py-4 text-sm text-gray-900 text-center">No Expenses found.</td>
                </tr>
              ) : (
                BalanceTransfer.map((balance) => {
                  return (
                    <tr key={balance.id}>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        <input
                          type="checkbox"
                          name="donation"
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500"
                          checked={balanceTransferIds.includes(balance.id)}
                          onChange={() => handleCheckboxChange(balance.id)}
                        />
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {balance.fromBankName}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {balance.toBankName}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {balance.donationType}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {balance.donationPurpose}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">
                        {new Date(balance.transferedOn).toLocaleDateString("hi-IN", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">{balance.amount}</td>
                      <td className="px-1 py-4 whitespace-nowrap text-sm text-gray-900">{balance.desc}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>


        <div className="mt-2">
          <p className="flex justify-center text-sm text-gray-700">
            Selected donation amount: {selectedBalanceTransferAmount} / {transactionAmount}
          </p>
        </div>


        <div className="flex justify-start mt-4">
          <button
            className={`bg-blue-500 text-white px-3 py-2 rounded-md mr-2 text-sm ${isSubmitEnabled ? "hover:bg-blue-600" : "opacity-50 cursor-not-allowed"}`}
            disabled={!isSubmitEnabled}
            onClick={() => {
              handleSubmit()
              onClose()
            }}
          >
            Submit
          </button>
          <button
            onClick={onClose}
            className="bg-blue-500 text-white px-3 py-2 rounded-md hover:bg-blue-600 mr-2 text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BalanceTransferModel;